(() => {
  const dialog = document.getElementById('AnsoPrivacy');
  if (!dialog || window.ansoPrivacy?.dialog === dialog) return;
  window.ansoPrivacy?.destroy();
  const controller = new AbortController();
  const options = { signal: controller.signal };
  window.ansoPrivacy = { dialog, destroy: () => controller.abort() };
  // Local preview has no storefront cookie domain. Its choices stay local and
  // never stand in for a Shopify consent record on the real storefront.
  const localPreview = ['localhost', '127.0.0.1', '::1', '[::1]'].includes(location.hostname);
  const previewKey = 'anso-preview-consent-v1';
  const error = dialog.querySelector('[data-privacy-error]');
  const customize = dialog.querySelector('[data-privacy-customize]');
  const save = dialog.querySelector('[data-privacy-save]');
  const inputs = [...dialog.querySelectorAll('input')];
  let loading;
  let saving = false;
  let interacted = false;
  const readPreview = () => {
    try { return JSON.parse(localStorage.getItem(previewKey)) || {}; } catch { return {}; }
  };
  const api = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!loading) loading = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('Privacy API unavailable')), 10000);
      const load = () => {
        if (controller.signal.aborted) { clearTimeout(timeout); reject(new Error('Disposed')); return; }
        if (!window.Shopify?.loadFeatures) { clearTimeout(timeout); reject(new Error('Privacy API unavailable')); return; }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], failure => {
          clearTimeout(timeout);
          if (failure || !window.Shopify.customerPrivacy) reject(failure || new Error('Privacy API unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        });
      };
      if (document.readyState === 'complete') load();
      else window.addEventListener('load', load, { once: true, signal: controller.signal });
    }).catch(failure => { loading = null; throw failure; });
    return loading;
  };
  const hasConsent = consent => inputs.every(input => ['yes', 'no'].includes(consent[input.name]));
  const populate = consent => inputs.forEach(input => { input.checked = consent[input.name] === 'yes'; });
  const show = async (manual = false) => {
    if (manual) interacted = true;
    if (controller.signal.aborted || saving) return;
    error.hidden = true;
    if (!dialog.open) dialog.showModal();
    try { populate(localPreview ? readPreview() : (await api()).currentVisitorConsent()); }
    catch { if (dialog.open) error.hidden = false; }
  };
  document.querySelectorAll('[data-privacy-open]').forEach(button => button.addEventListener('click', () => show(true), options));
  dialog.querySelector('[data-privacy-close]').addEventListener('click', () => { interacted = true; dialog.close(); }, options);
  dialog.addEventListener('cancel', () => { interacted = true; }, options);
  customize.addEventListener('click', () => {
    interacted = true;
    dialog.querySelector('#AnsoPrivacyPreferences').hidden = false;
    customize.setAttribute('aria-expanded', 'true');
    customize.hidden = true;
    save.hidden = false;
    inputs[0].focus();
  }, options);
  const record = async choice => {
    if (saving) return;
    saving = true;
    interacted = true;
    error.hidden = true;
    const buttons = [...dialog.querySelectorAll('button')];
    buttons.forEach(button => { button.disabled = true; });
    const consent = Object.fromEntries(inputs.map(input => [input.name, choice === 'save' ? input.checked : choice === 'accept']));
    try {
      if (localPreview) {
        localStorage.setItem(previewKey, JSON.stringify(Object.fromEntries(Object.entries(consent).map(([key, value]) => [key, value ? 'yes' : 'no']))));
      } else {
        const privacy = await api();
        await new Promise((resolve, reject) => {
          let settled = false;
          const matches = () => {
            const current = privacy.currentVisitorConsent();
            return Object.entries(consent).every(([key, value]) => current[key] === (value ? 'yes' : 'no'));
          };
          const finish = failure => {
            if (settled) return;
            settled = true;
            clearTimeout(timeout);
            document.removeEventListener('visitorConsentCollected', collected);
            failure ? reject(failure) : resolve();
          };
          const collected = () => { if (matches()) finish(); };
          const timeout = setTimeout(() => {
            // Some storefronts update consent without invoking the callback.
            matches() ? finish() : finish(new Error('Consent save timed out'));
          }, 10000);
          document.addEventListener('visitorConsentCollected', collected);
          try {
            privacy.setTrackingConsent(consent, result => {
              result?.error ? finish(new Error(result.error)) : finish();
            });
          } catch (failure) { finish(failure); }
        });
      }
      dialog.close();
    } catch { if (!controller.signal.aborted) error.hidden = false; }
    finally {
      saving = false;
      buttons.forEach(button => { button.disabled = false; });
    }
  };
  dialog.querySelectorAll('[data-privacy-choice]').forEach(button => button.addEventListener('click', () => record(button.dataset.privacyChoice), options));
  save.addEventListener('click', () => record('save'), options);
  if (localPreview) {
    if (!hasConsent(readPreview())) show();
  } else {
    api().then(privacy => {
      if (!controller.signal.aborted && !interacted && !hasConsent(privacy.currentVisitorConsent()) && privacy.shouldShowBanner()) show();
    }).catch(() => { /* The footer control allows retrying when the API becomes available. */ });
  }
})();
